module.exports = __webpack_public_path__ + "media/images/web/home/index/kind_of_events-4b8ae0314b3d51ba16da46980f09242d.webp";